import dayjs from "dayjs";
import { lazy, Suspense, useCallback, useMemo, useState } from "react";

import { HarvestSheetContext } from "./Context";
import type { OpenHarvestSheetParams } from "./Context";

const HarvestSheet = lazy(
  () => import("components/Dashboard/HarvestBanner/HarvestSheet")
);

export const HarvestSheetProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [params, setParams] = useState<OpenHarvestSheetParams | null>(null);

  const openHarvestSheet = useCallback((nextParams: OpenHarvestSheetParams) => {
    setParams(nextParams);
    setIsOpen(true);
  }, []);

  const value = useMemo(() => ({ openHarvestSheet }), [openHarvestSheet]);

  return (
    <HarvestSheetContext.Provider value={value}>
      {children}
      {params && (
        <Suspense fallback={null}>
          <HarvestSheet
            cropId={params.task.cropId}
            date={params.date}
            gardenCropId={params.task.gardenCropId}
            gardenId={params.task.gardenId}
            isOpen={isOpen}
            task={{
              end: dayjs(params.task.endDate),
              id: params.task.id,
              start: dayjs(params.task.startDate)
            }}
            onClose={() => setIsOpen(false)}
            onSaved={(response) => params.onSuccess?.(response)}
          />
        </Suspense>
      )}
    </HarvestSheetContext.Provider>
  );
};
